/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Role_Badge_CandidateInputs */

const en_admin_user_list_role_badge_candidate = /** @type {(inputs: Admin_User_List_Role_Badge_CandidateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`candidate`)
};

const de_admin_user_list_role_badge_candidate = /** @type {(inputs: Admin_User_List_Role_Badge_CandidateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kandidat`)
};

/**
* | output |
* | --- |
* | "candidate" |
*
* @param {Admin_User_List_Role_Badge_CandidateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_role_badge_candidate = /** @type {((inputs?: Admin_User_List_Role_Badge_CandidateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Role_Badge_CandidateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_role_badge_candidate(inputs)
	return en_admin_user_list_role_badge_candidate(inputs)
});